"use client";

import { BannerCarousel } from "@/components/ui/banner-carousel";
import type { MediaSoundPlacement } from "@/components/ui/media-sound-button";
import type { MediaData } from "@/db/schema/hiive";
import { ASPECT_RATIO_CLASS } from "@/lib/aspect-ratios";

interface HiiveBannerCarouselProps {
  bannerMedia: MediaData[];
  hiiveName: string;
  volumeButtonPosition?: MediaSoundPlacement;
  aspectRatio?: string;
  dotsClassName?: string;
  soundButtonClassName?: string;
}

export function HiiveBannerCarousel({
  bannerMedia,
  hiiveName,
  volumeButtonPosition = "bottom-right",
  aspectRatio = ASPECT_RATIO_CLASS.portrait4By5,
  dotsClassName,
  soundButtonClassName,
}: HiiveBannerCarouselProps) {
  return (
    <BannerCarousel
      media={bannerMedia}
      altName={hiiveName}
      volumeButtonPosition={volumeButtonPosition}
      aspectRatio={aspectRatio}
      dotsClassName={dotsClassName}
      soundButtonClassName={soundButtonClassName}
    />
  );
}
